import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SEO, seoFor } from "@/lib/seo";
import { lang, LANGUAGES, DEFAULT_LANG } from "@/i18n";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function SeoManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    const s = seoFor(pathname);
    const desc = s.description || SEO["/"].description;
    const base = `${window.location.origin}${pathname}`;
    const href = (l) => (l === DEFAULT_LANG ? base : `${base}?lang=${l}`);
    const url = href(lang);
    document.title = s.title;
    setMeta("name", "description", desc);
    setMeta("name", "robots", s.robots || "index, follow");
    setMeta("property", "og:locale", LANGUAGES[lang].locale.replace("-", "_"));
    document.head.querySelectorAll('link[rel="alternate"][hreflang]').forEach((el) => el.remove());
    if (!s.robots) {
      [...Object.keys(LANGUAGES), "x-default"].forEach((l) => {
        const el = document.createElement("link");
        el.rel = "alternate";
        el.hreflang = l;
        el.href = href(l === "x-default" ? DEFAULT_LANG : l);
        document.head.appendChild(el);
      });
    }
    setMeta("property", "og:title", s.title);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:url", url);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = url;
  }, [pathname]);
  return null;
}
